import { TooltipProvider } from '@repo/shadcn';
import { FC, ReactNode } from 'react';

export const CommonProvider: FC<{ children: ReactNode }> = ({ children }) => {
    return <TooltipProvider delayDuration={10}>{children}</TooltipProvider>;
};
